'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Chevron = require('../Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

var _Earth = require('../icons/Earth');

var _Earth2 = _interopRequireDefault(_Earth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadcrumbNode = function BreadcrumbNode(_ref) {
  var label = _ref.label,
      taxonomyId = _ref.taxonomyId,
      onClickNode = _ref.onClickNode,
      onClickLink = _ref.onClickLink;

  var handleClickedButton = function handleClickedButton() {
    onClickNode(taxonomyId);
    onClickLink({
      clickEndLocation: 'Taxonomy Level',
      completion: false,
      linkName: label
    }, false);
  };

  return _react2.default.createElement(
    'div',
    { className: 'quiver-taxonomy-navigator__breadcrumb-node' },
    onClickNode ? _react2.default.createElement(
      'button',
      {
        className: 'quiver-taxonomy-navigator__breadcrumb-node__button',
        onClick: handleClickedButton
      },
      label === 'Earth' ? _react2.default.createElement(_Earth2.default, null) : label
    ) : _react2.default.createElement(
      'span',
      { className: 'quiver-taxonomy-navigator__breadcrumb-node__placeholder' },
      label
    ),
    _react2.default.createElement(_Chevron2.default, { direction: 'right' })
  );
};

BreadcrumbNode.propTypes = {
  label: _propTypes2.default.string,
  taxonomyId: _propTypes2.default.string,
  onClickNode: _propTypes2.default.func,
  onClickLink: _propTypes2.default.func
};

exports.default = BreadcrumbNode;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/BreadcrumbNode.js
// module id = 678
// module chunks = 11